import styled from 'styled-components';

import { Checkbox } from '@dreryk/react-components';

export const StyledUrgentField = styled(Checkbox)`
   margin-right: auto;
`;
